import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { AirportLocationGuideContent } from '@repo/components';
import styled from 'styled-components';

const AirportLocation = () => {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;

  return (
    <ReceiptLayout hasPadding={false}>
      <Title>
        {nationality === 'KOR' ? '세관 위치' : 'Customs & Tax Refund Kiosk'}
      </Title>
      <AirportLocationGuideContent nationality={nationality} />
    </ReceiptLayout>
  );
};

const Title = styled.h2`
  width: 100%;
  padding: 12px 20px 20px 20px;
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  box-shadow: 0px 4px 4px 0px rgba(216, 216, 216, 0.25);
  background-color: #fff;
`;

export default AirportLocation;
